import {
  productFamilyIdFormat,
  productIdFormat,
} from "@redotech/redo-model/ids";
import { ChannelSchema } from "@redotech/redo-model/marketplace/channels";
import { OpensearchPaginationCursorSchema } from "@redotech/redo-model/tables/table";
import * as z from "zod/v4";

const ProductCatalogItemSchema_ = z.object({
  id: productFamilyIdFormat.schema,
  title: z.string(),
  description: z.string().optional(),
  image: z.object({ url: z.string(), altText: z.string() }).nullish(),
  vendor: z.string().optional(),
  status: z.string().optional(),
  channels: z.array(ChannelSchema),
  prices: z.array(z.object({ amount: z.string(), currency: z.string() })),
  quantity: z.bigint(),
  committed: z.bigint(),
  reserved: z.bigint(),
  available: z.bigint(),
  updatedAt: z.date(),
  products: z.array(
    z.object({
      id: productIdFormat.schema,
      title: z.string(),
      sku: z.string(),
      vendor: z.string(),
      image: z.object({ url: z.string(), altText: z.string() }).nullish(),
      quantity: z.bigint(),
      committed: z.bigint(),
      reserved: z.bigint(),
      available: z.bigint(),
    }),
  ),
});

export const ProductCatalogItemSchema: z.ZodType<ProductCatalogItem> =
  ProductCatalogItemSchema_;
export interface ProductCatalogItem
  extends z.infer<typeof ProductCatalogItemSchema_> {}

export const getProductCatalog = {
  name: "getProductCatalog" as const,
  input: z.object({
    pageSize: z.number().min(1).max(100).optional().default(20),
    page: z.number().min(0).optional().default(0),
    search: z.string().optional(),
    sort: z
      .object({
        key: z.string(),
        direction: z.enum(["asc", "desc"]),
      })
      .nullish(),
    cursor: OpensearchPaginationCursorSchema.nullish(),
  }),
  output: z.object({
    catalogItems: z.array(ProductCatalogItemSchema),
    totalCount: z.number(),
    page: z.number(),
    pageSize: z.number(),
    cursor: OpensearchPaginationCursorSchema.nullish(),
  }),
};
